import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, PureComponent, useCallback, useContext, useMemo, } from 'react';
import ScheduleElement from 'console/tabs/legacy/schedule-element';
import { BoilerGroup, DayTimetable, HeatingCircuit, WeekTimetable, } from 'z3k-config';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { MaterialObjectSelection, StrictNumberInput, } from 'console/shared/components/fields';
import { AccordionWithValidation } from 'console/device-settings/z3k/components/material-utils/accordion-with-validation';
import { FormControlLabel, InputAdornment, Radio, RadioGroup } from '@mui/material';
import { boilersOptionsSelector } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { useBox } from 'shared/hooks/utils';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { MultipleSelectionTable, } from 'z3k-settings/components/material-utils/multiple-selection-table/multiple-selection';
var BoilerGroupType = BoilerGroup.BoilerGroupType;
import { createWeekTimetableWithZeroes } from 'z3k-parser/lib/week-timetable';
class BoilerGroupTimetables extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: -1,
        };
    }
    render() {
        const { boiler_names, boiler_timetables, day_timetables, week_timetables } = this.props;
        const dId2m = {};
        (day_timetables || []).forEach((dt) => {
            dId2m[dt.id] = dt.temp24;
        });
        const panels = boiler_timetables.map((week_id, tt_index) => {
            let data = new Array(7)
                .fill(0)
                .map(() => new Array(24).fill(0));
            (week_timetables || []).forEach((wt) => {
                if (wt.id === week_id) {
                    data = wt.temp7.map((dId) => dId2m[dId].map((id) => `M${id}`));
                }
            });
            const modes = {
                0: { name: 'ВЫКЛ', zone_temp: [null, 30] },
                1: { name: 'ВКЛ', zone_temp: [null, 20] },
                255: { name: 'Резерв', zone_temp: [null, 23] },
            };
            return {
                key: `panel-${week_id}`,
                title: boiler_names[tt_index],
                content: {
                    content: (_jsx(ScheduleElement, { tempschedule: data, 
                        // @ts-ignore не соответствует типам для старых приборов, но работает :)
                        modes: modes, show_temperature_selector: false, onScheduleChanged: (data) => {
                            const temps = [];
                            for (let i = 0; i < 7; ++i)
                                temps.push(data[i].map((ms) => +ms.slice(1)));
                            this.props.onChangeWeek(week_id, temps);
                        } })),
                },
            };
        });
        return (_jsx(AccordionWithValidation, { header: "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044E", validation_result: null, validation_warnings_result: null, children: panels }));
    }
}
export const BoilerGroupComponent = memo(function BoilerGroupComponent() {
    const z3k_name = 'boiler_groups';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const configBox = useBox(config);
    const onChangeWeek = useCallback((week_id, value) => {
        const week = WeekTimetable.get.byId(configBox.current, week_id);
        if (week) {
            let newConfig = configBox.current;
            week.temp7.forEach((dayId, dayNo) => {
                newConfig = DayTimetable.get.applySetterById(newConfig, dayId, {
                    temp24: value[dayNo],
                });
            });
            replace_config(newConfig);
        }
    }, [replace_config]);
    const boilers_options = boilersOptionsSelector(config);
    const day_timetables = DayTimetable.get.all(config);
    const week_timetables = WeekTimetable.get.all(config);
    const updateCascadeFlag = useCallback((config, boiler_group_list) => {
        const boilerIdList = boiler_group_list.flatMap(({ boiler_list }) => boiler_list);
        return HeatingCircuit.get.modify(config, () => true, (hc) => HeatingCircuit.setCascadeFlag(hc, boilerIdList.includes(hc.id)));
    }, []);
    const onChangeGroup = useCallback((group) => {
        let new_config = configBox.current;
        let timetables = [];
        if (BoilerGroup.getType(group) == BoilerGroup.BoilerGroupType.SCHEDULE &&
            (!group.timetables ||
                group.timetables.length !== group.boiler_list.length)) {
            timetables = group.boiler_list.map(() => {
                let weekId;
                [weekId, new_config] = createWeekTimetableWithZeroes(new_config);
                return weekId;
            });
        }
        if (BoilerGroup.getType(group) != BoilerGroup.BoilerGroupType.SCHEDULE) {
            timetables = [];
        }
        new_config = BoilerGroup.get.replaceById(new_config, group.id, {
            ...group,
            timetables,
        });
        replace_config(updateCascadeFlag(new_config, BoilerGroup.get.all(new_config)));
    }, [replace_config, updateCascadeFlag]);
    const onChangeBoilerList = (value) => {
        if (item.lead_boiler_id != null && value.includes(item.lead_boiler_id))
            onChangeGroup({
                ...item,
                boiler_list: value,
            });
        else
            onChangeGroup({
                ...item,
                boiler_list: value,
                lead_boiler_id: null,
            });
    };
    const handleChange = (event) => {
        onChangeGroup(BoilerGroup.setType(item, parseInt(event.target.value, 10)));
    };
    const boilerGroupsOptions = [
        {
            name: 'Группа котлов',
            options: boilers_options[0].options.filter((option) => item.boiler_list.includes(option.id)),
        },
    ];
    const id2names = {};
    boilers_options[0].options.forEach((item) => (id2names[item.id] = item.name));
    const boiler_names = item.boiler_list.map((id) => id2names[id]
        ? 'Расписание для «' + id2names[id] + '»'
        : 'Расписание для контура №' + id);
    const groupType = BoilerGroup.getType(item);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const leadBoilerIdEditingProps = useEditingProps(id, z3k_name, 'lead_boiler_id');
    const turnOnDelayEditingProps = useEditingProps(id, z3k_name, 'slave_boiler_switch_delay');
    const rotationPeriodEditingProps = useEditingProps(id, z3k_name, 'rotation_period');
    const turn_on_delay_field = useCallback((input_props) => (_jsx(StrictNumberInput, { min: 1, max: 300, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u043C\u0438\u043D" }), ...input_props })), []);
    const rotation_period_field = useCallback((input_props) => (_jsx(StrictNumberInput, { min: 1, max: 30, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u0441\u0443\u0442\u043A\u0438" }), ...input_props })), []);
    const multipleSelectionTableOptions = useMemo(() => {
        const result = [
            {
                title: 'Список котлов в группе',
                help_id: 'boiler_groups_boiler_list',
                z3k_field: 'boiler_list',
                options: boilers_options,
            },
        ];
        return result;
    }, [item, boilers_options]);
    return (_jsxs("div", { className: "ui-z3k-object", children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "boiler_groups_name", ...nameEditingProps }), _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, onChange: onChangeBoilerList }), _jsx(RadioGroup, { value: groupType, onChange: handleChange, children: [
                    [BoilerGroupType.CASCADE, 'каскад'],
                    [BoilerGroupType.RESERVE, 'резерв'],
                    [BoilerGroupType.PARALLEL, 'Параллельная работа'],
                    [BoilerGroupType.SCHEDULE, 'Расписание'],
                ].map(([mode, label]) => (_jsx(FormControlLabel, { value: mode, control: _jsx(Radio, { color: "primary" }), label: label }, mode))) }), groupType == BoilerGroupType.RESERVE && (_jsx(MaterialObjectSelection, { label: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439 \u043A\u043E\u0442\u0451\u043B", help_id: "boiler_groups_lead_boiler_id", options: boilerGroupsOptions, ...leadBoilerIdEditingProps })), groupType == BoilerGroupType.CASCADE && (_jsx(Control, { label: "\u041F\u0435\u0440\u0438\u043E\u0434 \u0440\u043E\u0442\u0430\u0446\u0438\u0438 \u043A\u043E\u0442\u043B\u043E\u0432", ...rotationPeriodEditingProps, field: rotation_period_field, help_id: "boiler_groups_rotation_period" })), groupType != BoilerGroupType.PARALLEL && (_jsx(Control, { label: "\u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F/\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0435\u0434\u043E\u043C\u043E\u0433\u043E \u043A\u043E\u0442\u043B\u0430", ...turnOnDelayEditingProps, field: turn_on_delay_field, help_id: "boiler_groups_slave_boiler_switch_delay" })), groupType == BoilerGroupType.SCHEDULE && (_jsx("div", { className: "bot", children: _jsx(BoilerGroupTimetables, { boiler_names: boiler_names, boiler_timetables: item.timetables, day_timetables: day_timetables, week_timetables: week_timetables, onChangeWeek: onChangeWeek }) }))] }));
});
